import { apiCalendar } from '~constants/api';

import { get } from '~libs/genericAction';
import { createThunks } from '~libs/reduxUtils';

export const typePrefix = 'weekly-planner-users';

const config = [
  {
    actionType: 'getOne',
    apiPath: `${apiCalendar}/appointments`,
    method: get,
  },
];

export const { getOne } = createThunks(typePrefix, config);
